import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import { getModalData } from "src/selectors";
import { hideModal } from "src/actions/modal.actions";
import TextInput from "../UI/TextInput";

/**
 * A common input modal with a single input
 *
 * modalProps.title {string} modal title
 * modalProps.message {string} message
 * modalProps.label {string} Label of the input
 * modalProps.type {'text' | 'number' | 'email'} type of the input
 * modalProps.initValue {string} initialValue
 * modalProps.action {() => void} action to be performed on confirmation
 * modalProps.validate {(string) => string} function to call to validate input, must return null if valid. otherwise error message
 */
class SingleInputModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.modalProps.initValue || "",
      errors: null,
    };
  }

  closeModal = () => {
    if (typeof this.props.modalProps.action === "function") {
      this.props.modalProps.action(undefined);
    }
    this.props.hideModal();
  };

  setError(error) {
    this.setState({
      errors: error
        ? {
            value: error,
          }
        : null,
    });
  }

  action = () => {
    let valid = true;
    if (typeof this.props.modalProps.validate === "function") {
      let error = this.props.modalProps.validate(this.state.value);
      this.setError(error);
      valid = !error;
    }
    if (!valid) return;

    if (typeof this.props.modalProps.action === "function") {
      this.props.modalProps.action(this.state.value);
    }
    this.props.hideModal();
  };

  render() {
    const { title = "Input", message = "", label = "", type = "text" } = this.props.modalProps;
    return (
      <Fragment>
        <div className="modal" style={{ display: "block" }} tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button type="button" className="close" onClick={this.closeModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="lead">{message}</div>
                <TextInput
                  name="value"
                  type={type}
                  label={label}
                  value={this.state.value}
                  onChange={(evt) => this.setState({ value: evt.target.value })}
                  status={this.state.errors}
                />
              </div>
              <div className="modal-footer">
                <button onClick={this.closeModal} className="btn">
                  Cancel
                </button>
                <button onClick={this.action} className="btn btn-primary">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop show" tabIndex="1" />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const modalProps = getModalData(state).modalProps;

  return {
    modalProps,
  };
};

const mapDispatchToProps = {
  hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleInputModal);
